import { FC, ComponentProps } from 'react';
import HighlighterExternalComponent from 'react-highlight-words';
import styleToCss from 'style-object-to-css-string';
import styled from 'styled-components';
import { Color } from '@altermaind/web/ui';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';

type Props = ComponentProps<typeof HighlighterExternalComponent> & {
  bgColor?: Color;
};

export const StyledHighlighter = styled(HighlighterExternalComponent)<Props>(
  ({ theme, bgColor = 'primary/interactive' }) => {
    const bgColorToUse = convertColorToRgba(theme?.colors[bgColor], 1) || '#197ef7';
    return `
  & > mark {
		${styleToCss({
      position: 'relative',
      backgroundColor: 'transparent',
      color: 'inherit',
      display: 'inline-block',
      whiteSpace: 'pre',
    })}
	}
  & > mark:before {
		content: "";
		${styleToCss({
      backgroundColor: bgColorToUse,
      borderRadius: '6px',
      paddingLeft: '2px',
      paddingRight: '2px',
      width: '100%',
      height: '100%',
      position: 'absolute',
      zIndex: '-10000',
      left: '-2px',
      top: '0',
      transition: 'all 0.5s',
      transitionTimingFunction: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    })}
	}
`;
  },
) as FC<Props>;

StyledHighlighter.defaultProps = {};
